/**
 * Citame no maneja "restaurantes" (concepto del admin Resto del que este panel es
 * un fork). El gate original consultaba `GET /restaurants`, endpoint inexistente en
 * el backend Citame → 403 que el browser reportaba como (falso) error de CORS y que
 * además redirigía a crear un restaurante que no aplica (NER-1774).
 *
 * Se deja como passthrough para no alterar el árbol de App.js; el control de acceso
 * real lo hace ProtectedRoute (rol del claim Cognito `custom:role`).
 */
function RequireRestaurant({ children }) {
  return children;
}

export default RequireRestaurant;
